import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_wd64rb2zkz: FaireRetailerEntity = {
  token: "r_wd64rb2zkz",
  type: "retailer",
  name: "Retailer",
  country: "USA",
  ownerUserToken: "u_4hrd67q6cn",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:21:25.069Z",
    importedBy: "entity-db-cli",
  },
  themeTokens: [
    "board_demo_r_wd64rb2zkz_hero_mothers_day",
    "board_demo_r_wd64rb2zkz_thi_007389e75d",
    "board_demo_r_wd64rb2zkz_thi_27eaa95ae2",
    "board_demo_r_wd64rb2zkz_thi_3657a70277",
    "board_demo_r_wd64rb2zkz_thi_dc767d9ede",
    "board_demo_r_wd64rb2zkz_thi_e3064223f2",
    "board_demo_r_wd64rb2zkz_thi_5c43b43988",
    "board_demo_r_wd64rb2zkz_thi_e427dc500a",
    "board_demo_r_wd64rb2zkz_thi_05f7e152e9",
    "board_demo_r_wd64rb2zkz_thi_f213bf9ae7",
  ],
};
